import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { getTypesList, postDevices, getgroupTree, getDevicesDetail, putDevicesDetail, getDevicesGroupDetail, postDevicesGroup, } from '@blade-sxp/monitor/api/device-management/control';
import DeviceAddress from './components/device-address.vue';
import VideoPlayer from '@blade-sxp/monitor/components/player/simple-player.vue';
import LocationEditor from '@blade-sxp/monitor/components/image-editor/device-editor/index.vue';
import DevicePosition from './components/device-position.vue';
import { ControlModule } from '@blade-sxp/monitor/store/control';
let default_1 = class extends Vue {
    title = '创建同级';
    groupName = '';
    srcMessage = require('@blade/common/assets/images/device.png');
    stepActive = 1;
    typesList = [];
    groupTree = [];
    dialogVisible = false;
    deviceId = '';
    urlFlag = false;
    currIndex = 0;
    parentId = 0;
    rtspAddress = '';
    groupIdvalue = '';
    form = {
        deviceType: '',
        rtspAddress: '',
        rtspReviewAddress: '',
        deviceName: '',
        deviceCategory: '',
        deviceCode: '',
        deviceSubCategory: '',
        groupId: '',
        ip: '',
        port: '',
        password: '',
        username: '',
        dir: '',
        protocolType: '',
        mapLabel: '',
        remark: '',
    };
    rtspHost = 'ws://10.8.10.1:30080/engine/video-ingress-ws/rtsp-over-ws';
    deviceIP = '';
    get rules() {
        return {
            deviceType: [
                {
                    required: true,
                    message: this.$t('device.pleaseSelectDeviceType'),
                    trigger: 'change',
                },
            ],
            rtspAddress: [
                {
                    required: true,
                    message: this.$t('device.pleaseEnterURL'),
                    trigger: 'change',
                },
            ],
            deviceName: [
                {
                    required: true,
                    message: this.$t('device.pleaseEnterDeviceName'),
                    trigger: 'blur',
                },
                { max: 200, message: this.$t('charactersLimit'), trigger: 'blur' },
            ],
            deviceCode: [
                {
                    required: true,
                    message: this.$t('device.pleaseEnterDeviceID'),
                    trigger: 'blur',
                },
                { max: 255, message: this.$t('charactersLimit'), trigger: 'blur' },
            ],
            deviceSubCategory: [
                {
                    required: true,
                    message: this.$t('device.pleaseSelectDeviceSmallCategory'),
                    trigger: 'blur',
                },
                { max: 255, message: this.$t('charactersLimit'), trigger: 'blur' },
            ],
            deviceCategory: [
                {
                    required: true,
                    message: this.$t('device.pleaseSelectDeviceBigCategory'),
                    trigger: 'blur',
                },
                { max: 255, message: this.$t('charactersLimit'), trigger: 'blur' },
            ],
            groupId: [
                {
                    required: true,
                    message: this.$t('device.pleaseSelectDeviceOrganisation'),
                    trigger: 'change',
                },
            ],
            // mapLabel: [
            //   {
            //     required: true,
            //     message: this.$t('mapPosition'),
            //     trigger: 'change',
            //     validator: (rule: any, value: any, callback: any) => {
            //       console.log('mapLabel:', this.form.mapLabel);
            //       if (!this.form.mapLabel) {
            //         callback(new Error(this.$t('mapPosition').toString()));
            //       } else {
            //         callback();
            //       }
            //     },
            //   },
            // ],
        };
    }
    fileList = [];
    fileUrl = require('@blade/common/assets/images/user.png');
    imgSrc = '';
    options = { radius: 10, drawCircleOption: { dashed: false, lineColor: ['#C7996F'], opacity: 1 } };
    outerCircles = []; // api: [{vertext:{x: 0.1, y:0.1}, option:{}, meta:{}}]
    currVal = '0';
    outerVisible = false;
    // private onSubmit() {
    //   this.$message('submit!');
    // }
    handleDrawCircles(circles) {
        const last = circles.pop();
        this.outerCircles = [last];
    }
    onCancel() {
        this.$emit('portraitCancel');
    }
    handleDragStart(node, $event) {
        this.$refs.tree.setCurrentKey(node.data.id);
        $event.dataTransfer.setData('drag', JSON.stringify(node.data));
    }
    handleDrag(node) {
        if (node.childNodes.length === 0) {
            return true;
        }
        return false;
    }
    handleRenderContent(h, { node, data, store }) {
        if (data.level !== 0) {
            return (<div class="content-left-item" style="width:100%">
          <div class={{ 'item-active': data.id === this.currIndex }} onDblclick={($e) => this.handleOndbclick($e, data)}>
            {data.name}
          </div>
        </div>);
        }
    }
    handleOndbclick(event, data) {
        this.groupIdvalue = data.name;
        this.form.groupId = data.id;
        this.$refs.deviceOrganisation.handleClose();
    }
    handleNodeClick(node) {
        this.currIndex = node.id;
        this.parentId = node.parentId;
    }
    handleAvatarSuccess(file) {
        var _this = this;
        var reader = new FileReader();
        reader.readAsDataURL(file.raw);
        reader.onload = function (e) {
            // 图片base64化
            var newUrl = this.result; // 图片路径
            _this.fileUrl = newUrl;
        };
    }
    handleNext() {
        this.$refs.form.validate((valid) => {
            if (valid) {
                let data = {};
                if (this.form.deviceType === 'VN_RTSP') {
                    data = {
                        deviceCategory: this.form.deviceCategory,
                        deviceCode: this.form.deviceCode,
                        deviceName: this.form.deviceName,
                        deviceSubCategory: this.form.deviceSubCategory,
                        deviceType: this.form.deviceType,
                        groupId: this.form.groupId,
                        rtspAddress: this.form.rtspAddress,
                        // vertices: this.form.mapLabel,
                        remark: this.form.remark,
                    };
                }
                else {
                    data = this.form;
                }
                if (this.deviceId) {
                    this.putDevicesDetail(data); // 修改设备
                }
                else {
                    this.postDevices(data); // 添加设备
                }
            }
        });
    }
    getTypesList() {
        getTypesList({}).then(resp => {
            this.typesList = resp.data.data;
        });
    }
    postDevices(data) {
        // 添加设备
        postDevices(data)
            .then(resp => {
            let a = this.$t('device.deviceAddedSuccessfully');
            this.$message({
                message: a,
                type: 'success',
            });
            this.$router.replace('/users/control');
        })
            .catch(err => {
            this.$message({
                message: err,
                type: 'error',
            });
        });
    }
    backEdit() {
        this.$router.replace('/users/control');
    }
    putDevicesDetail(data) {
        // 修改设备
        putDevicesDetail(this.deviceId, data)
            .then(resp => {
            let a = this.$t('device.deviceAddedSuccessfully');
            this.$message({
                message: a,
                type: 'success',
            });
            this.$router.replace('/users/control');
        })
            .catch(err => {
            this.$message({
                message: err,
                type: 'error',
            });
        });
    }
    getgroupTree() {
        // 设备所属组织
        getgroupTree().then(resp => {
            this.groupTree = resp.data.data.tree;
        });
    }
    handleConnect() {
        this.form.rtspAddress = this.$refs.rtsp.form.rtspAddress;
        this.form.deviceType = this.$refs.rtsp.form.deviceType;
        this.form.ip = this.$refs.rtsp.form.ip;
        this.form.port = new Number(this.$refs.rtsp.form.port);
        this.form.password = this.$refs.rtsp.form.password;
        this.form.username = this.$refs.rtsp.form.username;
        this.form.dir = this.$refs.rtsp.form.dir;
        if (this.$refs.rtsp.form.protocolType) {
            this.form.protocolType = this.$refs.rtsp.form.protocolType;
        }
        this.stepActive = 2;
        this.urlFlag = true;
    }
    changeType() {
        this.form.deviceType = this.$refs.rtsp.form.deviceType;
    }
    getDevicesDetail() {
        // 设备详情
        getDevicesDetail(this.deviceId).then(resp => {
            this.form = {
                ...resp.data.data,
                //  mapLabel: resp.data?.data?.vertices ?? '' 
            };
            // console.log('vertices:', this.form.mapLabel);
            this.outerCircles = resp.data?.data?.vertices ? [{ vertex: JSON.parse(resp.data.data.vertices) }] : [{ vertex: {} }];
            // this.form.rtspAddress = resp.data.data.rtspReviewAddress;
            // console.log(JSON.stringify(this.form));
            // 获取 groupName
            getDevicesGroupDetail(resp.data.data.groupId)
                .then(device => {
                this.groupIdvalue = device.data.data.name;
            })
                .catch(err => {
                this.$message({
                    message: err,
                    type: 'error',
                });
            })
                .finally(() => {
                this.getBase64Image();
            });
        });
    }
    created() {
        this.getgroupTree(); // 设备组列表
    }
    // 添加设备所属分组
    addGroup() {
        // console.log(111);
        this.dialogVisible = true;
    }
    handleSubmit() {
        let data = { name: this.groupName, parentId: 0 };
        postDevicesGroup(data)
            .then(resp => {
            this.getgroupTree();
            this.dialogVisible = false;
            this.$message({
                message: resp.data.message,
                type: 'success',
            });
        })
            .catch(err => {
            this.$message({
                message: err,
                type: 'error',
            });
        });
    }
    mounted() {
        const query = this.$route.query;
        const { id } = query;
        if (id) {
            this.deviceId = id;
            this.getDevicesDetail();
        }
        else {
            this.getBase64Image();
        }
    }
    async getBase64Image() {
        const img = new Image();
        img.onload = () => {
            const domEle = document.getElementsByClassName('item-wrapper')[0];
            console.log('domEle:', domEle);
            domEle.style.height = '165px';
            domEle.style.width = `${(img.naturalWidth / img.naturalHeight) * 165}px`;
            this.$refs['editorRef']?.init();
            // domEle.style.height="205px"
        };
        try {
            const res = await ControlModule.getDeviceImage();
            this.imgSrc = res.baseMapUrl;
            this.$nextTick(() => {
                img.src = res.baseMapUrl;
            });
        }
        catch (e) { }
    }
    handleClick() {
        this.outerVisible = true;
    }
    handleClose() {
        this.outerVisible = false;
    }
    handleConfirm(outerCircles) {
        console.log('confirm');
        this.outerVisible = false;
        this.outerCircles = outerCircles;
        console.log('outerCircles:', JSON.stringify(outerCircles[0].vertex));
        // this.form.mapLabel = JSON.stringify(outerCircles[0].vertex);
    }
};
default_1 = __decorate([
    Component({
        name: 'Form',
        components: {
            'type-rtsp': DeviceAddress,
            VideoPlayer,
            LocationEditor,
            DevicePosition,
        },
        i18n: {
            messages: {
                'en-us': {
                    liveVideo: 'Video Stream',
                    owningGroup: 'Group',
                    equipmentCategory: 'Main Category',
                    owningSubclass: 'Detailed Category',
                    charactersLimit: 'Input content within 200 characters',
                    toAdd: 'No Record, click to add',
                    mapLabel: 'Map Label',
                    mapPosition: 'Please select device position',
                    desc: 'Device description',
                },
                zh: {
                    liveVideo: '实时流视频',
                    owningGroup: '所属设备组',
                    equipmentCategory: '所属设备大类',
                    owningSubclass: '所属设备子类',
                    charactersLimit: '输入内容在200个字符以内',
                    toAdd: '暂无数据点击添加',
                    mapLabel: '地图标点',
                    mapPosition: '请选择设备位置',
                    desc: '用途描述',
                },
            },
        },
    })
], default_1);
export default default_1;
